// Customizable Area Start
import { BlockComponent } from "../../../framework/src/BlockComponent";
import { IBlock } from "../../../framework/src/IBlock";
import { runEngine } from "../../../framework/src/RunEngine";
import { Message } from "../../../framework/src/Message";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { File, FileFromLibrary, FunnelFileData } from "./types";
import { getToken } from "../../../components/src/AuthService";
import { getMediafileType } from "../../utilities/src/GetMediafileType";

export const configJSON = require("./config");

export type Props = {
  id?: string;
  classes?: any;
  navigation?: any;
  goBack: () => void;
  setFiles: (selectedFiles: File[]) => void;
  libraryType?: any;
  savedFunnelFiles?: FunnelFileData[];
};

interface S {
  filesFromLibrary: FileFromLibrary[];
  selectedFiles: FileFromLibrary[];
  error: string;
  brndlyReels: any;
  loading: boolean;
  showSettings: boolean;
  selectedFileForSettings: any;
  files: File[];
  savedFunnelFiles: FunnelFileData[];
  videoLoadingMap: Record<string, boolean>;
  deleteBrandlyConfirmationModal: boolean;
  uploadFunnelFilesLoading: boolean;
}

interface SS {
  navigation: any;
}

export default class EverybrandLibraryController extends BlockComponent<
  Props,
  S,
  SS
> {
  getMediaFilesApiCallId: string = "";
  getBranlyLibraryApiCallId: string = "";
  sendFilesApiCallId: string = "";
  brandlyDeleteApiCallId: string = "";

  constructor(props: Props) {
    super(props);
    this.subScribedMessages = [getName(MessageEnum.RestAPIResponceMessage)];

    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);

    this.state = {
      filesFromLibrary: [],
      selectedFiles: [],
      error: "",
      brndlyReels:'',
      loading: true,
      showSettings: false,
      selectedFileForSettings: null,
      files: [],
      savedFunnelFiles: [],
      videoLoadingMap: {},
      deleteBrandlyConfirmationModal: false,
      uploadFunnelFilesLoading: false,
    };
  }
  removeChoice = (choiceIndex: number) => {
    const { files } = this.state;
  
    const updatedFiles = files.map((file: any) => {
      if (file.selectedFile) {
        return {
          ...file,
          choices: file.choices.filter(
            (_: any, index: number) => index !== choiceIndex
          ),
        };
      }
  
      return file;
    });
  
    this.setState({
      files: updatedFiles,
    } as any);
  };

  async componentDidMount() {
    if (this.props.libraryType === "SOCIAL_SCROLL") {
      this.getMediaFiles();
    } else {
      this.getBeanlyLibrary();
    }
  }

  selectFile = (fileIndex: number) => {
    const selectedFile = this.state.filesFromLibrary[fileIndex];

    this.setState((prevState) => {
      let selectedFiles: FileFromLibrary[] = prevState.selectedFiles;

      if (
        !prevState.selectedFiles.find((file) => file.id === selectedFile.id)
      ) {
        selectedFiles.push(selectedFile);
      } else {
        selectedFiles = prevState.selectedFiles.filter(
          (file) => file.id !== selectedFile.id
        );
      }

      return {
        selectedFiles,
      };
    });
  };

  // selectBrndlyFile = (fileIndex: number) => {
  //   const selectedFile = this.state.brndlyReels?.data?.[fileIndex];
  //   if (!selectedFile) return;

  //   // Create a normalized file object that matches the expected structure
  //   const normalizedFile = {
  //     id: selectedFile?.id,
  //     type: selectedFile?.type,
  //     attributes: {
  //       ...selectedFile.attributes,
  //       // Use video URL from social_videos if available, otherwise use the main video
  //       files: selectedFile.attributes.social_videos?.[0]?.link || selectedFile.attributes.video
  //     }
  //   };

  //   this.setState(prevState => {
  //     // Check if file is already selected
  //     const fileExists = prevState.selectedFiles.some(file => file.id === normalizedFile.id);

  //     let newSelectedFiles;
  //     if (fileExists) {
  //       // Remove file if it's already selected
  //       newSelectedFiles = prevState.selectedFiles.filter(file => file.id !== normalizedFile.id);
  //     } else {
  //       // Add file if it's not selected
  //       newSelectedFiles = [...prevState.selectedFiles, normalizedFile];
  //     }

  //     // Update files array for the CreateEveryreelSettings component
  //     const updatedFiles = newSelectedFiles.map(file => ({
  //       filePreview: file.attributes.files,
  //       preview: file.attributes.files,
  //       name: `BrandlyReel_${file.id}`,
  //       type: "video/mp4",
  //       id: file.id,
  //       meta: {
  //         id: file.id,
  //         name: `BrandlyReel_${file.id}`
  //       }
  //     }));

  //     return {
  //       selectedFiles: newSelectedFiles,
  //       selectedFileForSettings: newSelectedFiles[0], // Keep the first file as the main one for settings
  //       files: updatedFiles,
  //       savedFunnelFiles: newSelectedFiles
  //     };
  //   });
  // };

  selectBrndlyFile = (fileIndex: number) => {
    const selectedFile = this.state.brndlyReels?.data?.[fileIndex];
    if (!selectedFile) return;

    // Create a normalized file object that matches the expected structure
    const normalizedFile = {
      id: selectedFile?.id,
      type: selectedFile?.type,
      attributes: {
        ...selectedFile.attributes,
        // Use video URL from social_videos if available, otherwise use the main video
        files: selectedFile.attributes.social_videos?.[0]?.link || selectedFile.attributes.video
      }
    };

    this.setState((prevState) => {
      let selectedFiles: any[] = prevState.selectedFiles;

      if (
        !prevState.selectedFiles.find((file) => file.id === selectedFile.id)
      ) {
        selectedFiles.push(normalizedFile);
      } else {
        selectedFiles = prevState.selectedFiles.filter(
          (file) => file.id !== selectedFile.id
        );
      }

      // Update files array for the CreateEveryreelSettings component (use first selected for settings)
      const updatedFiles = selectedFiles.length > 0 ? selectedFiles[0]?.attributes?.social_videos?.map((file:any) => ({
        filePreview: file.link,
        preview: file.link,
        name: file?.name || `BrandlyReel_${file.social_videoable_id}`,
        body: file?.body || `BrandlyReel_${file.social_videoable_id}`,
        type: "video/mp4",
        id: file.id,
        meta: {
          id: file.social_videoable_id,
          name: `BrandlyReel_${file.social_videoable_id}`
        },
        // Map API choice shape (button_type/link_url/calendar_url) to the shape
        // the settings UI reads (buttonType/link/calendar_link), so previously
        // saved choices show up instead of defaulting to an empty list.
        choices: (file?.choices || []).map((choice: any) => ({
          id: choice?.id,
          name: choice?.name || "",
          buttonType: choice?.button_type || choice?.buttonType || "",
          funnel_video_id:
            choice?.funnel_video_id != null ? String(choice.funnel_video_id) : undefined,
          link: choice?.link_url || choice?.link || "",
          calendar_link: choice?.calendar_url || choice?.calendar_link || "",
          showMenu: false,
        })),
      })) : [];

      return {
        selectedFiles,
        selectedFileForSettings: selectedFiles.length > 0 ? selectedFiles[0] : null,
        files: updatedFiles,
        savedFunnelFiles: selectedFiles.length > 0 ? [selectedFiles[0]] : []
      };
    });
  };

  acceptFiles = () => {
    console.log('this.state.selectedFiles?',this.state.selectedFiles);
    console.log('this.state.files?.length',this.state.files);
    
    if (!this.state.files?.length) {
      this.setState({ error: "No file added yet" });
      return;
    }
  
    const firstFile = this.state.selectedFiles?.[0];
  
    if (this.props?.libraryType) {
      this.props.setFiles(
        this.state.selectedFiles.map((file) => ({
          filePreview: file?.attributes?.files,
          preview: file?.attributes?.files,
          name: `Everyreel_${file?.id}`,
          type: getMediafileType(file?.attributes?.files) || "",
        }))
      );
      return;
    }
  
    this.setState({
      showSettings: true,
      selectedFileForSettings: firstFile || null,
    });
  };

  openDeleteBrandlyConfirmationModal = (event: React.MouseEvent) => {
    event.stopPropagation()
    this.setState((prevState) => ({ deleteBrandlyConfirmationModal: !prevState.deleteBrandlyConfirmationModal}));
  };

  closeSettings = () => {
    this.setState({ showSettings: false, selectedFileForSettings: null });
    if (this.props.libraryType === "SOCIAL_SCROLL") {
      this.getMediaFiles();
    } else {
      this.getBeanlyLibrary();
    }
  };

  addFiles = (files: File[]) => {
    const MAX_FILES = 15;
    this.setState((prevState) => {
      const currentFileCount = prevState.files.length;
      const newFileCount = files.length;
      const totalFiles = currentFileCount + newFileCount;

      // Check if adding new files would exceed the limit
      if (totalFiles > MAX_FILES) {
        const remainingSlots = MAX_FILES - currentFileCount;
        if (remainingSlots <= 0) {
          // Already at or over limit
          alert(`Maximum ${MAX_FILES} files allowed. Please remove some files before adding new ones.`);
          return null;
        } else {
          // Add only up to the limit
          const filesToAdd = files.slice(0, remainingSlots);
          alert(`Maximum ${MAX_FILES} files allowed. Only ${remainingSlots} file(s) added.`);
          this.sendFunnelFiles(filesToAdd);
        }
      }
      
      this.sendFunnelFiles(files);
    });
  };

  getMediaFiles = () => {
    this.setState({ loading: true, error: "" });
    const headerData = {
      "Content-Type": configJSON.libraryContentType,
      token: getToken(),
    };
    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.getMediaFilesApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headerData)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getMediaFilesEndpoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpGetMethod
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return requestMessage.messageId;
  };

  getBeanlyLibrary = () => {
    this.setState({ loading: true, error: "" });
    const headerData = {
      "Content-Type": configJSON.libraryContentType,
      token: getToken(),
    };
    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.getBranlyLibraryApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headerData)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getBranlyLibrary
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpGetMethod
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return requestMessage.messageId;
  };

  postDeleteFunnel = () => {
    if (this.state.selectedFiles.length === 0) return;

    // Delete all selected funnels
    this.state.selectedFiles.forEach((file) => {
      const funnelId = file.id;

      let requestMessage = new Message(
        getName(MessageEnum.RestAPIRequestMessage)
      );

      this.brandlyDeleteApiCallId = requestMessage.messageId;
      requestMessage.addData(
        getName(MessageEnum.RestAPIRequestHeaderMessage),
        JSON.stringify({
          "Content-Type": configJSON.postContentType,
          token: getToken(),
        })
      );
      requestMessage.addData(
        getName(MessageEnum.RestAPIResponceEndPointMessage),
        `${configJSON.createFunnelEndPoint}/${funnelId}`
      );
      requestMessage.addData(
        getName(MessageEnum.RestAPIRequestMethodMessage),
        configJSON.deletePostAPiMethod
      );
      runEngine.sendMessage(requestMessage.id, requestMessage);
    });
  };

  async receive(_from: string, message: Message) {
    const apiRequestCallId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );
    const restApiResponseId = getName(MessageEnum.RestAPIResponceMessage);
  
    // Handle Get Media Files API
    if (apiRequestCallId === this.getMediaFilesApiCallId) {
      this.handleGetMediaFilesAPIResponse(message);
    }
  
    // Handle Branly Library API
    else if (
      message.id === restApiResponseId &&
      apiRequestCallId === this.getBranlyLibraryApiCallId
    ) {
      this.handleGetBranlyLibraryAPIResponse(message);
    }

    if (apiRequestCallId === this.sendFilesApiCallId) {
      this.handleFunnelFilesAPIResponse(message);
    }

    if (apiRequestCallId === this.brandlyDeleteApiCallId) {
      this.handleBrandlyDeleteAPIResponse(message);
    }
  }
  
  sendFunnelFiles = (files: File[]) => {
    this.setState((prevState) => ({
      files: [...prevState.files, ...files],
      uploadFunnelFilesLoading: true,
    }));
    const formData = new FormData()

    files.forEach((file) => {
      formData.append("files[]", (file as unknown) as Blob);
    })

    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    )

    this.sendFilesApiCallId = requestMessage.messageId
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify({
        token: getToken(),
      })
    )
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.uploadFunnelFilesEndPoint
    )
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.PostAPiMethod
    )

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      formData
    )
    runEngine.sendMessage(requestMessage.id, requestMessage)
    return requestMessage.messageId
  };

  handleFunnelFilesAPIResponse = (message: Message) => {
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    this.setState({ uploadFunnelFilesLoading: false });

    if (!(responseJson?.data || responseJson?.message)) {
      return;
    }

    // Uploading a new video while the Brandly settings modal is already open
    // should just add it to the funnel in place, not navigate away from the modal.
    if (this.state.showSettings) {
      if (Array.isArray(responseJson.data)) {
        this.setState((prevState) => ({
          savedFunnelFiles: [...prevState.savedFunnelFiles, ...responseJson.data],
        }));
      }
      return;
    }

    this.props.goBack();
  };

  handleBrandlyDeleteAPIResponse = (message: Message) => {
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    if (responseJson?.message) {
      this.getBeanlyLibrary()
      this.setState({ deleteBrandlyConfirmationModal: false, loading: true })
    }
  };

  handleGetMediaFilesAPIResponse = (message: Message) => {
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );
    const error = message.getData(
      getName(MessageEnum.RestAPIResponceErrorMessage)
    );

    if (error || responseJson?.error || responseJson?.errors?.length) {
      this.setState({
        loading: false,
        error:
          error ||
          responseJson?.error ||
          responseJson?.errors?.[0] ||
          "Failed to load media files. Please try again.",
      });
      return;
    }

    if (responseJson?.data) {
      this.setState({
        loading: false,
        filesFromLibrary: responseJson?.data.reverse(),
        error: "",
      });
    } else {
      this.setState({
        loading: false,
        error: "No data received from the server.",
      });
    }
  };

  handleGetBranlyLibraryAPIResponse = (message: Message) => {
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );
    const error = message.getData(
      getName(MessageEnum.RestAPIResponceErrorMessage)
    );

    if (error || responseJson?.error || responseJson?.errors?.length) {
      this.setState({
        loading: false,
        error:
          error ||
          responseJson?.error ||
          responseJson?.errors?.[0] ||
          "Failed to load Brandly library. Please try again.",
      });
      return;
    }

    if (responseJson) {
      this.setState({
        loading: false,
        brndlyReels: responseJson,
        error: "",
      });
    } else {
      this.setState({
        loading: false,
        error: "No data received from the server.",
      });
    }
  };
}

// Customizable Area End
